import React from 'react'

import Component from './component'

const Container = (props) => {

  const mergedProps = {
  }

  return (
    <Component {...mergedProps} />
  )
}

export default Container
